import React from "react";
import DelayTimePicker from "./DelayTimePicker";
import TickMark from "../../assets/check-pink.svg";

const DelayTimeWrapper = (props) => {
  const { data, handleRadioBtn, handleHr, handleMin, handleMeridiem } = props;
  return (
    <div>
      <div className="d-flex  align-items-sm-start align-items-lg-center align-items-start">
        {data?.showRadioBtn && (
          <div
            className="d-flex align-items-lg-start align-items-lg-center align-items-start mr-sm-3 mr-lg-2 mr-3 delay-radio-btn-container"
            // style={{ marginTop: "13px" }}
          >
            <input
              type="radio"
              value={data?.doctor_schedule_id}
              id={data?.doctor_schedule_id}
              checked={data?.checked}
              name="delay_id"
              className="delay-radio-btn"
              onChange={handleRadioBtn}
            />
          </div>
        )}

        <div className="d-flex w-100 flex-sm-column flex-lg-row flex-column  justify-content-between">
          {/* px-sm-2 px-lg-2 px-0 */}
          <div className="pr-sm-0 pr-lg-3 pr-0">
            <DelayTimePicker
              inputLabel={"Slot Start Time"}
              timeError={data?.hasStartError}
              hour={data?.start_hr}
              min={data?.start_min}
              meridiem={data?.start_meridiem}
              disabled={!data?.checked}
              handleHr={handleHr}
              handleMin={handleMin}
              handleMeridiem={handleMeridiem}
              doctor_schedule_id={data?.doctor_schedule_id}
              name="start_time"
              delay_schedule_id={data?.delay_schedule_id}
              status={data?.status}
              error_message={data?.start_message}
            />
          </div>
          <div className="pl-sm-0 pl-lg-3 pl-0  pt-sm-2 pt-lg-0 pt-2">
            <DelayTimePicker
              inputLabel={"Slot End Time"}
              timeError={data?.hasEndError}
              hour={data?.end_hr}
              min={data?.end_min}
              meridiem={data?.end_meridiem}
              disabled={!data?.checked}
              handleHr={handleHr}
              handleMin={handleMin}
              handleMeridiem={handleMeridiem}
              doctor_schedule_id={data?.doctor_schedule_id}
              name="end_time"
              delay_schedule_id={data?.delay_schedule_id}
              status={data?.status}
              error_message={data?.end_message}
            />
          </div>
        </div>
        {data?.showTick && (
          <div
            className="d-sm-none d-lg-flex d-none align-items-center ml-2"
            style={{
              marginTop: "20px",
              width: "15px",
              height: "15px",
              maxWidth: "15px",
            }}
          >
            {data?.delay_schedule_id && data.status == "1" && (
              <img
                src={TickMark}
                alt=""
                style={{ width: "15px", height: "15px", maxWidth: "15px" }}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DelayTimeWrapper;
